export const PmIcons = [
    { label: 'achat_ticket', path: 'assets/ico/achat_ticket_icon.svg' },
    { label: 'adherer_icon', path: 'assets/ico/adherer_icon.svg' },
    { label: 'alert-circle', path: 'assets/ico/alert-circle.svg' },
    { label: 'alize', path: 'assets/ico/rechargement_de_vehicule_electrique_icon.svg' },
    { label: 'apprendre_a_rouler', path: 'assets/ico/apprendre_a_rouler_icon2.svg' },
    { label: 'arret_covoiturage', path: 'assets/ico/arret_covoiturage_icon.svg' },
    { label: 'assurer_velo', path: 'assets/ico/assurer_son_velo_icon.svg' },
    { label: 'astuces', path: 'assets/ico/astuces_icon.svg' },
    { label: 'autopartage', path: 'assets/ico/autopartage_icon.svg' },
    { label: 'autoroute', path: 'assets/ico/autoroute.svg' },
    { label: 'autostop', path: 'assets/ico/autostop_icon.svg' },
    { label: 'carpool', path: 'assets/ico/covoiturage_icon.svg' },
    { label: 'chevron-right', path: 'assets/ico/chevron-right.svg' },
    { label: 'chevron-right-grey', path: 'assets/ico/chevron-right-grey.svg' },
    { label: 'chevron-right-white', path: 'assets/ico/chevron-right-white.svg' },
    { label: 'close', path: 'assets/ico/close.svg' },
    { label: 'consigne_velo', path: 'assets/ico/consigne_a_velo_icon.svg' },
    { label: 'edit', path: 'assets/ico/ico-edit.svg' },
    { label: 'evenement', path: 'assets/ico/evenement_icon.svg' },
    { label: 'help', path: 'assets/ico/help.svg' },
    { label: 'info', path: 'assets/ico/info.svg' },
    { label: 'info-trafic', path: 'assets/ico/info_trafic.svg' },
    { label: 'location_velo', path: 'assets/ico/location_velo_icon.svg' },
    { label: 'marquer_velo', path: 'assets/ico/marquer_son_velo_icon.svg' },
    { label: 'mobilites-douces', path: 'assets/ico/mobilites-douces.svg' },
    { label: 'navette', path: 'assets/ico/navette_aeroport_icon_white.svg' },
    { label: 'new', path: 'assets/ico/new.svg' },
    { label: 'nous_trouver', path: 'assets/ico/nous_trouver_icon.svg' },
    { label: 'parking', path: 'assets/ico/parking_en_ouvrage_icon.svg' },
    { label: 'plan', path: 'assets/ico/plan_icon.svg' },
    { label: 'plus', path: 'assets/ico/plus-black.svg' },
    { label: 'pony', path: 'assets/ico/Pony-Logo.svg' },
    { label: 'proof_carpool', path: 'assets/ico/preuve_de_covoiturage_icon.svg' },
    { label: 'proteger_velo', path: 'assets/ico/proteger_son_velo_icon.svg' },
    { label: 'qr-code', path: 'assets/ico/qrcode_icon.svg' },
    { label: 'reparation_velo', path: 'assets/ico/reparer_son_velo_icon.svg' },
    { label: 'star_black', path: 'assets/ico/star_black.svg' },
    { label: 'star_active', path: 'assets/ico/star_active.svg' },
    { label: 'star_white', path: 'assets/ico/star_white.svg' },
    { label: 'stationnement', path: 'assets/ico/stationnement_en_voirie_icon.svg' },
    { label: 'taxi', path: 'assets/ico/taxi_icon.svg' },
    { label: 'tier', path: 'assets/ico/TIER-logo.svg' },
    { label: 'time', path: 'assets/ico/time.svg' },
    { label: 'tourisme', path: 'assets/ico/tourisme_icon.svg' },
    { label: 'transport-commun', path: 'assets/ico/transport-commun.svg' },
    { label: 'valider_ticket', path: 'assets/ico/valider_ticket_icon.svg' },
    { label: 'velo', path: 'assets/ico/velo_icon.svg' },
    { label: 'velo_taxi', path: 'assets/ico/velo_taxi_icon.svg' },
    { label: 'voiture', path: 'assets/ico/voiture.svg' },
    { label: 'voiture-white', path: 'assets/ico/voiture_white.svg' },
    { label: 'ztl', path: 'assets/ico/ztl_icon2.svg' }
];